import { ISpace } from '@/types';
import {
  DreamValue,
  Navbar,
  Navbar2Element,
} from '@typedream/core';
import { ELEMENT_NAVBAR } from '@typedream/dream-editor';

type Data = {
  pageContent?: DreamValue,
  space: ISpace,
};

/**
 * Create valid navbar plugin from space
 * @param spaceNavbar
 * @returns
 */
export const createFromSpaceNavbar = (spaceNavbar: Navbar): Navbar2Element => ({
  children: [{ text: '' }],
  type: ELEMENT_NAVBAR,
  ...spaceNavbar,
});

/**
 * Create page content with navbar where navbar is taken from space.
 * The `space.navbar` is the single source of truth.
 * @param data
 * @returns
 */
export function createPageContentWithSpaceNavbar(
  data: Data,
) {
  const { space, pageContent } = data;
  const spaceNavbar = space?.navbar;

  // It the space doesn't have a navbar, we should remove the navbar from the page content.
  if (!spaceNavbar) {
    // Only remove the first child if it's a navbar.
    if (pageContent[0].children[0].type === ELEMENT_NAVBAR) {
      const pageContentChildrenWithoutFirstChildren = pageContent[0].children.slice(1);
      return [{
        ...pageContent[0],
        children: [
          ...pageContentChildrenWithoutFirstChildren,
        ],
      }] as unknown as DreamValue;
    }

    return pageContent;
  }

  // If the `pageContent` already has a navbar, we should replace it with the navbar from the space.
  if (pageContent[0].children[0].type === ELEMENT_NAVBAR) {
    return [{
      ...pageContent[0],
      children: [
        createFromSpaceNavbar(spaceNavbar),
        ...pageContent[0].children.slice(1),
      ],
    }] as unknown as DreamValue;
  }

  return [{
    ...pageContent[0],
    children: [
      createFromSpaceNavbar(spaceNavbar),
      ...pageContent[0].children,
    ],
  }] as unknown as DreamValue;
}
